import { canUseDOM } from '@lib/canUseDOM';
var lang = 'en';
var supportedLanguages = new Set(['ru', 'en', 'ka']);
export function setLang(newLang) {
  lang = newLang;
}
export function getLang() {
  return lang;
}
export function i18nFactory(keyset) {
  return function (key) {
    return keyset[lang][key];
  };
}
export var isLanguageSupported = function isLanguageSupported(language) {
  return supportedLanguages.has(language);
};
export function getSupportedLanguage(languages) {
  return languages.find(isLanguageSupported);
}
export function initI18n() {
  var currentLanguage = getSupportedLanguage(navigator.languages);
  if (currentLanguage) {
    setLang(currentLanguage);
  }
}
if (canUseDOM) {
  initI18n();
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any